// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a820f20a","239":"20ddb9b2","453":"8d86898f","732":"7ec9a9e4"}[chunkId] + ".chunk.js";
};